export const getObjective = /* GraphQL */ `
  query GetObjective($id: ID!, $sk: String!) {
    getObjective(id: $id, sk: $sk) {
      id
      sk
      abbreviation
      annotations {
        content
        label
      }
      authorityId
      authority {
        id
      }
      content
      guid
      idAuthority
      idPublisher
      name
      notes
      outlineNumber
      parentId
      scope
      sequence
      type
      tags {
        key
        type
        value
      }
    }
  }
`;

export const listObjectives = /* GraphQL */ `
  query ListObjectives(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelObjectiveFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listObjectives(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sk
        guid
        type
        name
        content
        numRaw
        numEnhanced
        sequence
        idAuthority
        idPublisher
        parentId
        scope
        objectiveTree
        workflowStatus
        isObsolete
      }
    }
  }
`;

export const listObjectivesByScopeSequence = /* GraphQL */ `
  query ListObjectivesByScopeSequence(
    $scope: String
    $sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelObjectiveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectivesByScopeSequence(
      scope: $scope
      sequence: $sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scope
        abbreviation
        annotations {
          content
          label
        }
        notes
        outlineNumber
        parentId
        content
        sequence
        tags {
          key
          type
          value
        }
      }
      nextToken
    }
  }
`;

export const getObjectivesView = /* GraphQL */ `
  query GetObjectivesView(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getObjectivesView(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      workspaceId
      schemaVersion
      bankId
      name
      type
      subject
      grade
      maturity
      creatorId
      objectiveScope
      data
    }
  }
`;
